<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <form @submit.prevent="saveUserRole">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Edit user role') }}</h1>
                    </div>
                </div>
            </div>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="mt-6 shadow sm:rounded-sm">
                    <loading :status="loading"/>
                    <div class="bg-white md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
                        <div class="md:col-span-1">
                            <h3 class="text-lg font-medium leading-6 text-gray-900">{{ $t('Role details') }}</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-500">
                                {{ $t('This information will be displayed publicly') }}.
                            </p>
                        </div>
                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="name">{{ $t('Name') }}</label>
                                    <div class="mt-1 relative rounded shadow-sm">
                                        <input
                                            id="name"
                                            v-model="userRole.name"
                                            :placeholder="$t('Name')"
                                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                            required
                                        >
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="stage-footer-surface text-right px-4 py-3 sm:px-6">
                        <span class="inline-flex">
                            <router-link
                                class="btn btn-secondary shadow-sm rounded mr-4"
                                :to="userRoleListPath"
                            >
                                {{ $t('Close') }}
                            </router-link>
                            <button
                                class="btn btn-gray shadow-sm rounded"
                                type="submit"
                            >
                                {{ $t('Save') }}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </form>
    </main>
</template>

<script>
import {resolveReturnToPath} from "@/utils/list-route-state";

export default {
    name: "edit-user-role",
    metaInfo() {
        return {
            title: this.$i18n.t('Edit user role')
        }
    },
    data() {
        return {
            loading: true,
            userRole: {
                name: null,
            },
        }
    },
    mounted() {
        this.getUserRole();
    },
    computed: {
        userRoleListPath() {
            const isSettingsRoute = String(this.$route && this.$route.path ? this.$route.path : '').startsWith('/workspace/admin/settings/user-roles');
            const fallbackPath = isSettingsRoute ? '/workspace/admin/settings/user-roles' : '/workspace/admin/user-roles';
            return resolveReturnToPath(this.$route.query || {}, fallbackPath);
        },
    },
    methods: {
        saveUserRole() {
            const self = this;
            self.loading = true;
            axios.put('api/workspace/admin/user-roles/' + self.$route.params.id, self.userRole).then(function () {
                self.loading = false;
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.loading = false;
            });
        },
        getUserRole() {
            const self = this;
            self.loading = true;
            axios.get('api/workspace/admin/user-roles/' + self.$route.params.id).then(function (response) {
                self.userRole = response.data;
                self.loading = false;
            }).catch(function () {
                self.loading = false;
                self.$router.push(self.userRoleListPath);
            });
        },
    }
}
</script>
